import { ExerciseDTO, PlanUnit, PlanWorkout, ExerciseConfig, TrainingPlan } from '@/generated';
import { useUpdatePlan as useUpdatePlanMutation } from '@/hooks/plan-mutation.hooks';

export enum MutationOperation {
  Increment,
  Decrement,
}

export enum MutationType {
  Linear,
}

type UpdateProps = {
  roundIndex: number;
  exerciseIndex: number;
  selectedExercise?: ExerciseDTO;
  exerciseConfig?: ExerciseConfig;
  rowMutationParameter?: { op: MutationOperation; type: MutationType };
  replaceRow: boolean;
};

export const useUpdatePlan = (plan?: TrainingPlan, workout?: PlanWorkout, unit?: PlanUnit) => {
  const planMutation = useUpdatePlanMutation();

  return async (props: UpdateProps) => {
    const { exerciseIndex, roundIndex, selectedExercise, replaceRow, exerciseConfig, rowMutationParameter } = props;
    if (plan && plan.units)
      await planMutation.mutateAsync({
        notifyUsers: false,
        plan: {
          ...plan,
          units: plan.units.map((g) =>
            g.idClient === unit?.idClient
              ? {
                  ...unit,
                  workouts: unit.workouts.map((wu) =>
                    wu.idClient === workout?.idClient
                      ? {
                          ...wu,
                          rounds: wu.rounds.map((r, ri) =>
                            ri === roundIndex || replaceRow
                              ? {
                                  exercises: r.exercises.map((e, ei) => {
                                    const config = exerciseConfig ? { ...exerciseConfig } : ({ ...selectedExercise?.config } as any); //TODO: Fix
                                    if (rowMutationParameter && ei === exerciseIndex) {
                                      const maxReps = config?.value ?? 0;
                                      let cval = wu.rounds.length - ri;
                                      if (rowMutationParameter.op === MutationOperation.Increment) cval = ri + 1;
                                      const currentReps = (maxReps / wu.rounds.length) * cval;
                                      config.value = Math.ceil(currentReps);
                                    }

                                    return ei === exerciseIndex ? { exerciseId: selectedExercise?.id ?? '', exerciseConfig: config } : e;
                                  }),
                                }
                              : r,
                          ),
                        }
                      : wu,
                  ),
                }
              : g,
          ),
        },
      });
  };
};
